import { Store } from '@webtides/element-js';

/**
 * @property {Array<TabPanel>} panels
 */
export default class TabRegisterStore extends Store {
    links = [];
    panels = [];
    selects = [];
    navs = [];

    /**
     * @param {'link' | 'panel' | 'select' | 'nav'} type
     * @param {HTMLElement} element
     */
    register(type, element) {
        if (type === 'link' && !this.links.includes(element)) {
            this.links.push(element);
        } else if (type === 'panel' && !this.panels.includes(element)) {
            this.panels.push(element);
        } else if (type === 'select' && !this.selects.includes(element)) {
            this.selects.push(element);
        } else if (type === 'nav' && !this.navs.includes(element)) {
            this.navs.push(element);
        }
        this.requestUpdate();
    }

    /**
     * @param {'link' | 'panel' | 'select' | 'nav'} type
     * @param {HTMLElement} element
     */
    unregister(type, element) {
        if (type === 'link') {
            this.links = this.links.filter((e) => e !== element);
        } else if (type === 'panel') {
            this.panels = this.panels.filter((e) => e !== element);
        } else if (type === 'select') {
            this.selects = this.selects.filter((e) => e !== element);
        } else if (type === 'nav') {
            this.navs = this.navs.filter((e) => e !== element);
        }
        this.requestUpdate();
    }
}
